import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
@Entity("harvest_report")
export class HaverstReport {
    @PrimaryGeneratedColumn("increment", { name: 'harvest_report_id' })
    harvestReportId: number;

    @Column({
        nullable: false,
        name: "harvest_date"
    })
    harvestDate: Date;
   
    @Column("varchar", {
        nullable: false,
        name: "farmer_data"
    })
    farmerData: string;

    @Column("varchar",{
        nullable: false,
        name: "harvest_time"
    })
    harvestTime: string;
    
    @Column("varchar", {
        nullable: false,
        name: "product"
    })
    product: string;

    @Column("int", {
        nullable: false,
        name: "quantity"
    })
    quantity: number;   

    @Column("varchar", {
        nullable: false,
        name: "temp_1"
    })
    temperature1: string;

    @Column("varchar", {
        nullable: false,
        name: "temp_2"
    })
    temperature2: string;

    @Column("varchar", {
        nullable: false,
        name: "temp_3"
    })
    temperature3: string;

    @Column("varchar", {
        nullable: false,
        name: "temp_4"
    })
    temperature4: string;

    @Column("varchar", {
        nullable: false,
        name: "temp_5"
    })
    temperature5: string;      

    @Column("boolean", {
        nullable:false,
        default:true,
        name: "clean_boxes"
      })
    cleanBoxes: boolean;

    @Column("boolean", {
        nullable:false,
        default:true,
        name: "hygine_handle"
      })
    hygineHandle: boolean;

    @Column("boolean", {
        nullable:false,
        default:true,
        name: "healthy_shrimps"
      })
    healthyShrimps: boolean;

    @Column("boolean", {
        nullable:false,
        default:true,
        name: "chill_killed"
      })
    chillKilled: boolean;

    @Column("boolean", {
        nullable:false,
        default:true,
        name: "proper_icing"
      })
    properIcing: boolean;

    @Column("varchar", {
        nullable: false,
        name: "vehicle_no"
    })
    vehicleNo: string; 

    @Column("varchar", {
        nullable: false,
        name: "driver_name"
    })
    driverName: string; 

    @Column("varchar",{
        nullable: false,
        name: "vehicle_leaving_time"
    })
    vehicleLeavingTime: string;

    @Column("text", {
        nullable: false,
        name: "remarks"
    })
    remarks: string;

    @Column({
        type: 'int',
        nullable: true,
        default: 0,
        name: 'plant_id'
    })
    plantId: number;
    

    @Column("int", {
        nullable: null,
        name: "indent_id",
    })
    indentId: number;

    @Column("int", {
        nullable: null,
        name: "indent_item_id",
    })
    indentItemId: number;

    @Column("varchar", {
        nullable: false,
        name: "seal_no"
    })
    sealNo: string;

    @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
    })
    isActive:boolean;

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        default: 'Admin',
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
}

